import { Outlet } from 'react-router-dom';

import { Navbar } from 'navbar';
import { Box, Stack } from '@mui/material';

function RootPage() {
  return (
    <div className="App">
      <Box width={1}>
        <Stack spacing={2}>
          <Navbar />
          <Outlet />
        </Stack>
      </Box>
    </div>
  );
}

export default RootPage;
